import { StyledSwitch, StyledSwitchContainer, StyledSwitchLabel, SwitchWrapperForLabels } from './CustomSwitch.styles'
import { CustomSwitchProps } from './CustomSwitch.types'

// Note: This is used with google address input and styles is custom for that
const CustomSwitch = ({ checked, onChange, label, alignSelf, showYesNoLabels = false }: CustomSwitchProps) => {
  return (
    <StyledSwitchContainer alignSelf={alignSelf}>
      {showYesNoLabels ? (
        <SwitchWrapperForLabels>
          <StyledSwitchLabel>No</StyledSwitchLabel>
          <StyledSwitch checked={checked} onChange={onChange ? onChange : undefined} />
          <StyledSwitchLabel>Yes</StyledSwitchLabel>
        </SwitchWrapperForLabels>
      ) : (
        <StyledSwitch checked={checked} onChange={onChange ? onChange : undefined} />
      )}
      {label && <StyledSwitchLabel>{label}</StyledSwitchLabel>}
    </StyledSwitchContainer>
  )
}

export default CustomSwitch
